export default __webpack_public_path__ + "static/media/logoWhite1.66325299.png";